import { ProjectMeta, UploadProjectsResponse } from '@anm/api/modules/uploads/types';
import useSwitchState from '@anm/hooks/useSwitchState';
import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { videoFolderActions, videoFolderSelectors } from '../../../../store/modules/videoFolder';

const useProjectsModal = (projectId: string, closeDeleteModal: () => void) => {
  const dispatch = useDispatch();
  const [isProjectsModal, openProjectsModal, closeProjectsModal] = useSwitchState();

  const onProjectsModalClose = useCallback(() => {
    closeProjectsModal();
    dispatch(videoFolderActions.clearDeleteProject());
  }, []);

  const deleteProjectState = useSelector(videoFolderSelectors.selectDeleteProject);

  const deleteError = deleteProjectState.error;
  const canOpenModal = projectId === deleteProjectState.projectId;

  const uploadProjects = useRef<ProjectMeta[]>([] as ProjectMeta[]);

  useEffect(() => {
    if (!deleteError || deleteError.code !== 400) return;

    try {
      const resp = JSON.parse(deleteError?.message || '') as UploadProjectsResponse;

      uploadProjects.current = resp.projects;
      canOpenModal && openProjectsModal();
      closeDeleteModal();
    } catch {
      console.error('Could not parse delete project error response');
    }
  }, [deleteError?.message]);

  return [isProjectsModal, uploadProjects.current, onProjectsModalClose] as const;
};

export default useProjectsModal;
